<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <notification-dropdown class="right-menu-item hover-effect" />
      <div style="display: flex;flex-direction: column;line-height: 10px;justify-content: center;align-items: center;">
        <div style="color: white; font-size: 12px;">
          {{ user.name }}
        </div>
        <div style="color: #c9cad3;font-size: 10px;">
          {{ roles }}
        </div>
      </div>
      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <img v-if="avatar" :src="avatar" class="user-avatar">
          <img v-else src="/svg/user.png" class="user-avatar">
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/my-account">
            <el-dropdown-item>
              {{ $t('navbar.profile') }}
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span style="display: block" @click="logout">{{
              $t('navbar.logOut')
            }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <template v-if="device !== 'mobile'">
        <!-- <search id="header-search" class="right-menu-item" /> -->
        <screenfull id="screenfull" class="right-menu-item hover-effect" />

        <!-- <el-tooltip :content="$t('navbar.size')" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip> -->

        <!-- <lang-select class="right-menu-item hover-effect" /> -->
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import Screenfull from '@/components/Screenfull';
import NotificationDropdown from '@/components/NotificationDropdown';
import Cookies from 'js-cookie';
// import SizeSelect from '@/components/SizeSelect';
// import LangSelect from '@/components/LangSelect';
// import Search from '@/components/HeaderSearch';

export default {
  target: 'none',
  components: {
    Breadcrumb,
    Hamburger,
    Screenfull,
    NotificationDropdown,
    // SizeSelect,
    // LangSelect,
    // Search,
  },
  data() {
    return {
      playAlert: false,
      audio: new Audio(),
      user: {},
      roles: '',
    };
  },
  computed: {
    ...mapGetters(['sidebar', 'name', 'avatar', 'device', 'userId']),
  },
  async created() {
    Cookies.remove('alert');
    await this.getUser();
    // setTimeout(() => {
    //   // this.audio = new Audio('/mp3/ketnoi.mp3');
    //   // this.audio.play();
    //   this.timer = setInterval(this.getAlert, 1000);
    // }, 500);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  beforeRouteLeave(to, from, next) {
    console.log(to, from, next);
    clearInterval(this.timer);
  },
  unmounted() {
    clearInterval(this.timer);
  },
  methods: {
    async getUser() {
      // await this.$store.dispatch('user/getInfo');
      this.user = this.$store.state.user;
      // console.log(this.$store.state.user);
      this.roles = this.getRole();
    },
    getRole() {
      const _roles = this.user.roles.map(value => this.$options.filters.uppercaseFirst(value));
      return _roles.join(' | ');
    },
    showMessageClose(msg) {
      this.playAlert = true;
      this.$alert(msg, 'Thông báo', {
        confirmButtonText: 'Đóng', // 'Tắt âm thanh thông báo',
        callback: (action) => {
          console.log(action);

          this.audio.loop = false;
          this.playAlert = false;
        },
      });
    },
    quetQrSai() {
      this.showMessageClose('Cảnh báo sai thiết bị thao tác');
      // this.playAudio('/mp3/CanhbaoSaithietbi_Nam.mp3');
    },
    quetQrDung() {
      // this.playAudioRep('/mp3/Dungthietbithaotac_MBac.mp3', 3, 2500);
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    playAudio(sound) {
      if (sound) {
        this.audio = new Audio(sound);
        this.audio.play();
        this.audio.loop = this.playAlert;
      }
    },
    playAudioRep(sound, numberOfTimes = 3, delay = 3000, firstTime = true) {
      this.audio = new Audio(sound);
      if (firstTime) {
        this.audio.play();
      }
      setTimeout(() => {
        if (!firstTime) {
          this.audio.play();
        }
        numberOfTimes--;
        if (numberOfTimes > 0) {
          this.playAudioRep(sound, numberOfTimes, delay, false);
        }
      }, delay);
    },
    async logout() {
      await this.$store.dispatch('user/logout');
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: $navbarBg;
  box-shadow: 0 1px 4px rgba(221, 220, 220, 0.08);
  border-bottom: 0.5px solid #ffffff1a;

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;
    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #ffffff;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
